import React from 'react'
import { Divider } from 'antd'
import { CustomTag } from 'src/components'
import { useTranslation } from 'next-i18next'
import { useAppSelector } from 'src/app/hooks'
import { validateProjectIdForStockSaleSelector } from 'src/features'

const ProjectBrokerageTabs: React.FC<{ projectIdHasError: boolean }> = ({ projectIdHasError }) => {
  const { t } = useTranslation()
  const { loading: loadingValidateProjectId, project } = useAppSelector(validateProjectIdForStockSaleSelector)

  const tagState = loadingValidateProjectId ? 'loading' : projectIdHasError ? 'error' : project && 'success'

  const tag = {
    loading: { type: 'processing', text: t('admin.Brokerage.ValidateProject') },
    error: { type: 'error', text: t('admin.Brokerage.ProjectsError') },
    success: { type: 'success', text: project?.name },
  }[tagState]

  if (!tag) return

  return <>
    <CustomTag type={tag?.type} text={tag?.text} />
    <Divider />
  </>
}

export default ProjectBrokerageTabs
